import React, { useContext, useEffect, useRef } from "react";

import { Context } from "../../provider/index.js";
import languageData from "../../data/language.json";
import { generateName } from "../general/NameGenerator.js";

import Footer from "../general/Footer.js";
import Border from "../general/Border.js";
import Header from "../general/Header.js";

const PickerScreen = () => {
  const names = useRef([])
  const { admin, dispatch } = useContext(Context);
  const currentLanguage = admin.language;
  const textData = languageData[currentLanguage];

  useEffect(() => {
    dispatch({ type: "option", payload: 0 });
    dispatch({ type: "maxOptions", payload: 100 });
    dispatch({ type: "rulesToSwitch", payload: false });
  }, []);

  useEffect(() => {
    let newName

    if (names.current[admin.option]) {
      newName = names.current[admin.option]
    } else {
      newName = generateName();
      names.current.push(newName)
    }

    dispatch({ type: "randomName", payload: newName });
  }, [admin.option]);

  return (
    <div className="uiContainer">
      <Header />

      <div
        className="uiField uiFieldBorders"
        style={{ width: admin.size.w, height: admin.size.h }}
      >
        <div className="pickerContainer">
          <h3 className="pickerTitle">{textData.pickerPage.message}</h3>

          <div className="pickerButtons">
            <div
              className={`pickerButtonsItem btn ${
                admin.activeButton == "up" ? "active" : ""
              }`}
            >
              <img src="./images/buttons/arrowUp.png" alt="arrowUp" />
            </div>

            <h1 className="randomName">{admin.randomName}</h1>

            <div
              className={`pickerButtonsItem btn ${
                admin.activeButton == "down" ? "active" : ""
              }`}
            >
              <img src="./images/buttons/arrowDown.png" alt="arrowDown" />
            </div>
          </div>

          <Border />
        </div>
      </div>

      <Footer>
        <div className="playButtons">
          <div className="btn 5" id="Playbutton">
            <img src="./images/buttons/skipButton.png" alt="arrowDown" />
          </div>
          <div className="btn 4" id="playButton2">
            {textData.welcomePage.button}
          </div>
        </div>
      </Footer>
    </div>
  );
};

export default PickerScreen;
